import React from 'react';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';
import { BackLink, HeaderActions, HeaderRow, PageTitle } from '../eInvoice.styles';

const CouponPageHeader = ({ backTo, backLabel, title, actions }) => (
  <>
    <BackLink>
      <Link to={backTo}>
        <Icon type="left" style={{ marginRight: 8 }} />
        {backLabel}
      </Link>
    </BackLink>
    <HeaderRow>
      <PageTitle>{title}</PageTitle>
      {actions ? <HeaderActions>{actions}</HeaderActions> : null}
    </HeaderRow>
  </>
);

export default CouponPageHeader;
